<template>
    <BaseCard padding="md" class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div class="flex-1 min-w-0 flex flex-col gap-1">
            <div class="body-semibold text-ink truncate">{{ cycle.template.name }}</div>
            <div class="scaffold-body-small text-ink-muted">
                <template v-if="cycle.awaiting_self_reflection">
                    {{ cycle.responded_count }} of {{ Math.max(cycle.total_invited, 1) }} responses recorded. {{ t("reflections.active360.pastAwaitingSelf") }}
                </template>
                <template v-else-if="kind === 'sixty'"> {{ cycle.responded_count }} of {{ Math.max(cycle.total_invited, 1) }} responses recorded </template>
                <template v-else>Completed reflection</template>
            </div>
            <div v-if="dateLabel" class="scaffold-body-small text-ink-muted">{{ dateLabel }}</div>
        </div>
        <a
            v-if="cycle.awaiting_self_reflection"
            :href="`/reflections/360/${cycle.id}/results`"
            class="base-btn-primary base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="`${t('reflections.active360.pastComplete')} ${cycle.template.name}`"
            @click.prevent="emit('view', cycle.id)">
            {{ t("reflections.active360.pastComplete") }}
        </a>
        <a
            v-else-if="cycle.has_report"
            :href="`/reflections/360/${cycle.id}/results`"
            class="base-btn-neutral base-btn-sm sm:shrink-0 whitespace-nowrap text-center self-start sm:self-auto"
            :aria-label="`${VIEW_RESULTS_TEXT} ${cycle.template.name}`"
            @click.prevent="emit('view', cycle.id)">
            {{ VIEW_RESULTS_TEXT }}
        </a>
        <!-- A closed cycle with no report is terminal (raters fell short, or
             the wait for the self reflection timed out), even when it had
             unlocked. Otherwise no report with `unlocked_at` set means the
             report is legitimately on its way. -->
        <span v-else-if="cycle.closed_without_report" class="details text-ink-muted sm:shrink-0 sm:self-center">Closed without a report</span>
        <BaseButton
            v-else-if="cycle.unlocked_at"
            type="button"
            theme="neutral"
            size="sm"
            disabled
            class="shrink-0 self-start sm:self-auto whitespace-nowrap flex items-center gap-2">
            <i class="bi bi-arrow-repeat animate-spin" aria-hidden="true"></i>
            Generating…
        </BaseButton>
        <span v-else class="details text-ink-muted sm:shrink-0 sm:self-center">Closed without a report</span>
    </BaseCard>
</template>

<script setup lang="ts">
import type { PastCycleSummary } from "~vue/api/generated/reflections";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import { formatDate } from "~vue/utils/threeSixty";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const VIEW_RESULTS_TEXT = "View Results";

interface Props {
    cycle: PastCycleSummary;
    kind: "sixty" | "self";
}

const { cycle } = defineProps<Props>();
const emit = defineEmits<{ (event: "view", cycleId: string): void }>();
const { t } = useI18n();

const dateLabel = computed(() => formatDate(cycle.unlocked_at || cycle.closed_at, "long"));
</script>
